module.exports = __webpack_public_path__ + "static/media/home.32f57b6c.svg";